module.exports = __webpack_public_path__ + "img/6d60b0b.png";